import Vimeo from '@vimeo/player';

function pauseOtherVimeoInstances(currentIframe) {
    document.querySelectorAll('iframe[data-vimeo-id]').forEach(iframe => {
        if (iframe !== currentIframe) {
            try {
                const player = new Vimeo(iframe);
                player.getMuted().then(isMuted => {
                    if (!isMuted) {
                        player.pause();
                    }
                });
            } catch (error) {
                console.error('Error pausing other Vimeo instances:', error);
            }
        }
    });
}

function handleHighlights() {
    const el = document.querySelector('.section-highlights');
    const videos = el.querySelectorAll('.video');

    videos.forEach(function (video) {
        video.addEventListener('click', function () {
            const modalId = video.getAttribute('data-modal-id');
            const modal = document.getElementById(modalId);

            if (modal) {
                modal.style.display = 'block';
                document.body.classList.add('no-scroll');

                const iframe = modal.querySelector('iframe');
                const vimeoId = iframe.getAttribute('data-vimeo-id');
                const close = modal.querySelector('.modal-close');

                // Pause other Vimeo videos that are playing with audio
                pauseOtherVimeoInstances(iframe);

                if (iframe) {
                    try {
                        const player = new Vimeo(iframe, {
                            id: vimeoId,
                            autoplay: 1,
                            muted: 0,
                        });
                        player.play();
                    } catch (error) {
                        console.error('Error initializing Vimeo player:', error);
                    }
                }

                if (close) {
                    close.addEventListener('click', function () {
                        modal.style.display = 'none';
                        document.body.classList.remove('no-scroll');
                        try {
                            const player = new Vimeo(iframe, {
                                id: vimeoId,
                                autoplay: 0,
                                muted: 0,
                            });
                            player.pause();
                        } catch (error) {
                            console.error('Error initializing Vimeo player:', error);
                        }
                    }, { once: true });
                }
            }
        });
    });
}

if (document.querySelector('.section-highlights')) {
    handleHighlights();
}